/**
 * Whether the platform shell around Bunker shows it right now. Inside the shell's Chat frame the
 * frame stays `visible` for the browser while the person is on another section of cispracs.ru, so
 * only the shell can say it (`cispracs:bunker-visibility`, lib/shellNotifications.ts). Until it
 * does — the normal app, Desktop, an older shell — Bunker counts as shown, as before.
 *
 * No imports on purpose: the notification gates read this from anywhere without pulling the
 * frame code in.
 */
let shown = true;

export function shellShowsBunker(): boolean {
  return shown;
}

export function setShellShowsBunker(value: boolean): void {
  shown = value;
}

/** For tests. */
export function resetShellVisibilityForTest(): void {
  shown = true;
}
